module.exports = __webpack_public_path__ + "static/media/cards-team-front-5.4ee1f41b.webp";